import { render, staticRenderFns } from "./FormConfirm.vue?vue&type=template&id=2f49a404&scoped=true"
import script from "./FormConfirm.vue?vue&type=script&lang=js"
export * from "./FormConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49a404",
  null
  
)

export default component.exports